/**
 * @todo add autoloader
 */

export default {
  storeModules: {
  }
}
